var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errorMessage)?_c('div',{staticClass:"reject-tips"},[_c('div',{staticClass:"icon-horn"},[_c('lottie-this',{staticClass:"animation",attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}})],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }